// extracted by mini-css-extract-plugin
module.exports = {"root":"YoutubeVideoModal_root__2Me15","video":"YoutubeVideoModal_video__qT6xj","iframe":"YoutubeVideoModal_iframe__3T0tp","closeBtn":"YoutubeVideoModal_closeBtn__3FoDS"};